import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Post from './post.js';
import fetchPost from '../actions/fetch-post.js';

const PostContainer = withRouter(connect(
  (state) => ({
    postName: state.posts.postName,
    post: state.posts.post
  }),
  (dispatch) => ({
    fetchPost: (postName) => dispatch(fetchPost(postName))
  })
)(Post));

export default PostContainer;
